import React from "react";
import "./styles.scss";

interface IProps {
  // Todo: fix this
  color:
    | "green"
    | "red"
    | "blue"
    | "light-blue"
    | "yellow"
    | "gray"
    | "grayStatic";
  children: any;
  disabled?: boolean;
  icon?: any;
  onClick?(): void;
}

const OutlineButton = (props: IProps) => {
  return (
    <div
      className={`outline-button ${
        !props.disabled ? props.color : "grayStatic"
      }`}
      onClick={props.onClick}
    >
      {props.icon && <span className="icon">{props.icon}</span>}
      {props.children}
    </div>
  );
};

export default OutlineButton;
